function posOutletSummary() {
    const vm = this;
    vm.$onInit = () => {
        const totalCount = vm.outletsSummaryData.totalCount;
        const notInheritingCount = vm.outletsSummaryData.notInheritingCount;

        vm.outletLabel = totalCount + ' outlet(s), ' + notInheritingCount + ' not using merchant settings';
    };
}
angular.module('qkr.integration.settings')
    .component('posOutletSummary', {
        template: require('./pos-outlet-summary.html'),
        bindings: {
            outletsSummaryData: '<'
        },
        controller: posOutletSummary,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./src/integration-settings/components/children-components/types/pos-feature/pos.outlet.summary.component.js